export default __webpack_public_path__ + "static/media/deals.99ba4eeb.svg";